module.exports = __webpack_public_path__ + "img/text5.0a90e8c4.webp";